import { useRef } from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { Alert } from 'components'
import s from './styles.module.scss'

export default function PaymentQr({
  userName,
  phoneNo,
  plan,
  amountRupees,
  paymentUrl,
  onCloseModal,
}) {
  const qrWrapRef = useRef(null)

  const downloadQr = () => {
    const svg = qrWrapRef.current?.querySelector('svg')
    if (!svg) return

    const svgData = new XMLSerializer().serializeToString(svg)
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const img = new Image()

    img.onload = () => {
      canvas.width = img.width
      canvas.height = img.height
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, 0, 0)
      const pngFile = canvas.toDataURL('image/png')
      const downloadLink = document.createElement('a')
      const safeName = (userName || 'user').replace(/\s+/g, '-').toLowerCase()
      downloadLink.download = `bcn-payment-qr-${safeName}.png`
      downloadLink.href = pngFile
      downloadLink.click()
      Alert.success('QR code downloaded. Share it with the user on WhatsApp.')
    }

    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)))
  }

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(paymentUrl)
      Alert.success('Payment link copied to clipboard.')
    } catch {
      Alert.error('Could not copy link. Please copy it manually.')
    }
  }

  const shareWhatsApp = () => {
    const digits = (phoneNo || '').replace(/\D/g, '')
    const mobile = digits.length >= 10 ? digits.slice(-10) : ''
    const amountLine = amountRupees != null ? `₹${amountRupees}` : 'the membership fee'
    const message = encodeURIComponent(
      `Hi ${userName || 'there'},\n\nPlease complete your BCN membership payment (${plan}) — ${amountLine}.\n\nScan the QR code I'm sending, or pay here:\n${paymentUrl}\n\nThank you!`
    )
    const url = mobile
      ? `https://wa.me/91${mobile}?text=${message}`
      : `https://wa.me/?text=${message}`
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className={s.main}>
      <div className={s.card}>
        <button type="button" className={s.closeBtn} onClick={onCloseModal} aria-label="Close">
          <span className="material-icons-outlined">close</span>
        </button>

        <h2 className={s.title}>Payment QR Code</h2>
        <p className={s.subtitle}>
          {userName} · {plan}
          {amountRupees != null && <span className={s.amount}> · ₹{amountRupees}</span>}
        </p>

        <div className={s.qrWrap} ref={qrWrapRef}>
          <QRCodeSVG
            value={paymentUrl}
            size={220}
            level="M"
            includeMargin
            fgColor="var(--c-primary)"
          />
        </div>

        <p className={s.hint}>
          User can scan this QR to pay via UPI, card, or net banking on Razorpay.
          Download the image and send it on WhatsApp, or let them scan from your screen.
        </p>

        <div className={s.actions}>
          <button type="button" className={s.btnPrimary} onClick={downloadQr}>
            <span className="material-icons-outlined">download</span>
            Download QR
          </button>
          <button type="button" className={s.btnWhatsApp} onClick={shareWhatsApp}>
            <span className="material-icons-outlined">chat</span>
            WhatsApp
          </button>
          <button type="button" className={s.btnSecondary} onClick={copyLink}>
            <span className="material-icons-outlined">content_copy</span>
            Copy link
          </button>
        </div>

        <p className={s.linkPreview} title={paymentUrl}>
          {paymentUrl}
        </p>
      </div>
    </div>
  )
}
